import React from "react";
import Select from "../commons/Select";
import SidebarFrame from "./SidebarFrame";
import CheckboxInput from "../commons/CheckboxInput";
import ReactPaginate from "react-paginate";
import SchrankInput from "../commons/SchrankInput.jsx";
import SockelSettings from "./SockelSettings";
import MeasureNumberInput from "../commons/MeasureNumberInput.js";

export default class KorpusSettings extends SidebarFrame {
    renderTitle() {
        return I18N("Korpus");
    }

    dachschraege(modell) {
        const werte = APP.metadata.Modellwerte[modell.Name];
        return werte ? werte["dachschraege"] : null;
    }

    get verdeckterSchenkel() {
        return APP.arrangement.eckschrankRechtsVerdeckt;
    }

    set verdeckterSchenkel(s) {
        APP.arrangement.changeEckschrankVerdeckung();
    }

    get schrank() {
        return APP.arrangement.selectedSchrank;
    }

    set schrank(s) {
        APP.arrangement.selectedSchrank = s;
    }

    renderBody() {
        const schrank = APP.arrangement.selectedSchrank;
        const hasSchraegeLinks = schrank.dachschraegeSeite == "left";
        const hasSchraegeRechts = schrank.dachschraegeSeite == "right";
        const sockelOptionEnabled = APP.arrangement.selectedSchrank.options.getBool('sockel');
        const showModels = !APP.configuration.Code && APP.arrangement.schraenke.length === 1;
        const possibleNoRueckwand = APP.metadata.Modelle[schrank.modell.Name].OhneRueckwand;
        const possibleNoOberboden = APP.metadata.Modelle[schrank.modell.Name].OhneOberboden;
        const possibleExtenzer = true; //falls das mal festgelegt werden sollte: APP.metadata.Modelle[schrank.modell.Name].MitExzenterVerbindung;
        const hasMultipleSchraenke = APP.arrangement.schraenke.length > 1;
        const possibleForms = schrank.getPossibleForms().map(possbileForm => {
            return {
                Code: possbileForm,
                image: SETTINGS.wkfgContentBaseUrl + "Konfiguration/" + possbileForm + "/screenshot_0_closed.jpg"
            }
        });

        const elemente = [];
        // Das ist nur eine Heuristik. Einbauten werden nicht berücksichtigt. Es kann ein Dialog erscheinen, der die Änderung ablehnt.
        const schrankElementsBox = schrank.elementsBox.getSize();
        const minElemente = Math.max(
            Math.ceil(schrankElementsBox.x / schrank.options.getMaxValue("element_breite")),
            schrank.options.getMinValue("anzahl_elemente", 1)
        );

        let maxElemente = Math.min(
            Math.floor(schrankElementsBox.x / schrank.options.getMinValue("element_breite")),
            schrank.options.getMaxValue("anzahl_elemente", 15)
        );
        // debugger;
        // Passen die Seitenwände noch rein? Falls nein - 1;
        const rest = schrankElementsBox.x - maxElemente * schrank.options.getMinValue("element_breite");
        if (rest < (maxElemente - 1) * schrank.options.getFloat("brett_staerke")) {
            maxElemente -= 1;
        }
        for (let i = minElemente; i <= maxElemente; i++) {
            elemente.push({ value: i, label: i });
        }

        const isSchwebetuer = APP.arrangement.selectedSchrank.isSchwebetuer;

        const minSockelHoehe = APP.arrangement.selectedSchrank.options.getFloat('minimaleSockelhoehe')/10;
        const maxSockelHoehe = APP.arrangement.selectedSchrank.options.getFloat('maximaleSockelhoehe')/10;

        return (
            <div>
                {APP.arrangement.schraenke.length > 1 && (
                    <div className="d-flex flex-column justify-content-center">
                        <label>{I18N("Welchen Schrank möchten Sie bearbeiten?")}</label>
                        <ReactPaginate
                            previousLabel={"Vorherige"}
                            nextLabel={"Nächste"}
                            breakLabel={"..."}
                            pageCount={APP.arrangement.schraenke.length}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={2}
                            initialPage={APP.arrangement.selected.schrankIdx}
                            forcePage={APP.arrangement.selected.schrankIdx}
                            onPageChange={(data) => {
                                const schrank = APP.arrangement.schraenke[data.selected];
                                APP.arrangement.selectedSchrank = schrank;
                                APP.arrangement.currentSchrankIndex = APP.arrangement.selected.schrankIdx;
                                //force rerender;
                                this.setState({});
                            }}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                            containerClassName={"pagination"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item nomobile"}
                            previousLinkClassName={"page-link-previous"}
                            nextClassName={"page-item nomobile"}
                            nextLinkClassName={"page-link-next"}
                            activeClassName={"active"}
                        />
                    </div>
                )}

                <div className="sidebar-subheader row">
                    <div className="left col-1"></div>
                    <div className="middle col-12">
                        <div className="sidebar-title">{I18N("KorpusTitle")}</div>
                    </div>
                </div>
                {showModels && possibleForms.length > 0 && (
                    <Select
                        label={I18N("Welche Form soll Ihr Schrank haben?")}
                        value={schrank.modell}
                        options={possibleForms.map(form => form.Code)}
                        getLabel={(x) => x.Anzeigename}
                        isSameValue={(a, b) => a.Name == b.Name}
                        onChange={(modell) => {
                            APP.model.tryCompile(() => {
                                schrank.setModell(modell);
                            });
                            APP.cameraAnimation();
                        }}
                    />
                )}
                {!showModels && possibleForms.length > 0 && (
                    // <Select
                    //     label={I18N("Welche Form soll Ihr Schrank haben?")}
                    //     value={schrank.createdFromInspiration}
                    //     options={possibleForms}
                    //     getLabel={(x) => x}
                    //     isSameValue={(a, b) => a == b}
                    //     onChange={async (inspiration) => {
                    //         await schrank.setFromInspiration(inspiration);
                    //         APP.model.tryCompile(() => {
                    //             APP.model.compile();
                    //         });
                    //     }}
                    // />
                    <SchrankInput
                        value={possibleForms.find(possibleForm => possibleForm.Code === schrank.createdFromInspiration)}
                        values={possibleForms}
                        isEqual={(value1, value2) => {
                            return value1.Code === value2.Code;
                        }}
                        getLabel={(model) => {
                            return _.find(APP.metadata.Inspirationen, (inspiration) => inspiration.Code === model.Code)?.Label
                        }}
                        onChange={async (model) => {
                            const inspiration = model.Code;
                            await schrank.setFromInspiration(inspiration);
                            APP.model.tryCompile(() => {
                                APP.model.compile();
                            });
                        }}
                    >
                        <label>{I18N("Welche Form soll Ihr Schrank haben?")}</label>
                    </SchrankInput>
                )}

                <MeasureNumberInput
                    label={I18N(`Wie breit soll Ihr Schrank sein?`)}
                    value={schrank.size.x}
                    onCommit={APP.model.tryWrap(this, (value) => schrank.setDimension("x", value))}
                />
                <MeasureNumberInput
                    label={I18N(`Wie hoch soll Ihr Schrank sein?`)}
                    value={schrank.size.y}
                    onCommit={APP.model.tryWrap(this, (value) => schrank.setDimension("y", value))}
                />
                <MeasureNumberInput
                    label={I18N(`Wie tief soll Ihr Schrank sein?`)}
                    value={schrank.size.z}
                    onCommit={APP.model.tryWrap(this, (value) => schrank.setDimension("z", value))}
                />

                {"none" != schrank.angleSide && (
                    <MeasureNumberInput
                        label={I18N("Wie hoch ist der Kniestock?")}
                        value={schrank.sizeTop.y}
                        onCommit={APP.model.tryWrap(this, (value) => schrank.setDimensionTop("y", value))}
                    />
                )}
                {["left", "right"].includes(schrank.angleSide) && (
                    <MeasureNumberInput
                        label={I18N("Wie breit ist der Schrank oben?")}
                        value={schrank.sizeTop.x}
                        onCommit={APP.model.tryWrap(this, (value) => schrank.setDimensionTop("x", value))}
                    />
                )}
                {"back" == schrank.angleSide && (
                    <MeasureNumberInput
                        label={I18N("Wie tief ist der Schrank oben?")}
                        value={schrank.sizeTop.z}
                        onCommit={APP.model.tryWrap(this, (value) => schrank.setDimensionTop("z", value))}
                    />
                )}

                {/*currently disabled*/}
                {/* <Select
                    label={I18N(`Wieviele Elemente soll der Schrank haben?`)}
                    value={schrank.elements.length}
                    options={elemente}
                    onChange={APP.model.tryWrap(this, (value) => schrank.setNumberOfElements(value))}
                /> */}

                {!schrank.isSchwebetuer && (
                    <div>
                        <a className="" onClick={() => APP.uiHandler.sidebar("elemente")}>
                            {I18N("Elemente festlegen")}
                        </a>
                    </div>
                )}

                {schrank.needsPassleiste && (
                    <div className="input-wrapper appear">
                        <label className="productdrag image-text">
                            {I18N("Passleiste")}
                            <div className="info" onClick={() => APP.uiHandler.showHelpPopup(APP.findProduct("Passleiste"))}></div>
                        </label>
                        <CheckboxInput
                            id={"passleisteLinks"}
                            label={I18N("PassleisteLinks")}
                            value={schrank.passleiste.senkrechteLinks}
                            onChange={APP.model.tryWrap(this, (value) => {
                                schrank.passleiste.senkrechteLinks = value;
                            })}
                        />
                        <CheckboxInput
                            id={"passleisteRechts"}
                            label={I18N("PassleisteRechts")}
                            value={schrank.passleiste.senkrechteRechts}
                            onChange={APP.model.tryWrap(this, (value) => {
                                schrank.passleiste.senkrechteRechts = value;
                            })}
                        />
                        {(hasSchraegeRechts || hasSchraegeLinks) && (
                            <CheckboxInput
                                id={"passleisteSchraege"}
                                label={I18N("PassleisteSchraege")}
                                value={schrank.passleiste.schraege}
                                onChange={APP.model.tryWrap(this, (value) => {
                                    schrank.passleiste.schraege = value;
                                })}
                            />
                        )}
                        <CheckboxInput
                            id={"passleisteOben"}
                            label={I18N("PassleisteOben")}
                            value={schrank.passleiste.oben}
                            onChange={APP.model.tryWrap(this, (value) => {
                                schrank.passleiste.oben = value;
                            })}
                        />
                    </div>
                )}
                
                {!isSchwebetuer && sockelOptionEnabled && (
                    <>
                    <div className="sidebar-subheader row">
                        <div className="left col-1"></div>
                        <div className="middle col-12">
                            <div className="sidebar-title">{I18N("KorpusSockelTitle")}</div>
                        </div>
                    </div>
                    <SockelSettings minHoehe={minSockelHoehe} maxHoehe={maxSockelHoehe}/>
                    </>
                )}
                
                <div className="sidebar-subheader row">
                    <div className="left col-1"></div>
                    <div className="middle col-12">
                        <div className="sidebar-title">{I18N("KorpusWeiteresTitle")}</div>
                    </div>
                </div>
                {possibleNoRueckwand && <CheckboxInput
                    id={"passleisteLinks"}
                    label={I18N("ohne Rueckwand")}
                    value={!schrank.withRueckwand}
                    onChange={APP.model.tryWrap(this, (value) => {
                        schrank.setNoRueckwand(value);
                    })}
                />}
                {possibleNoOberboden && <CheckboxInput
                    id={"passleisteLinks"}
                    label={I18N("ohne Deckel")}
                    value={!schrank.withDeckel}
                    onChange={APP.model.tryWrap(this, (value) => {
                        schrank.setNoDeckel(value);
                    })}
                />}
                {possibleExtenzer && <CheckboxInput
                    id={"exzenter"}
                    label={I18N("mit Exzenterverbindung")}
                    value={schrank.withExzenterverbindung}
                    onChange={APP.model.tryWrap(this, (value) => {
                        schrank.setExzenterverbindungOption(value);
                    })}
                />}
                {(possibleExtenzer && hasMultipleSchraenke) && <button
                    id={"exzenter_alle"}
                    className="primary finished-button"
                    value={schrank.withExzenterverbindung}
                    onClick={APP.model.tryWrap(this, () => {
                        APP.arrangement.setExzenterverbindungOption(schrank.withExzenterverbindung);
                    })}
                    >
                        {I18N("Exzentereinstellung auf alle übernehmen")}
                    </button>
                }

                {schrank && schrank.connectors.length === 1 && (
                    <div>
                        <hr></hr>
                        <button
                            className="red finished-button"
                            onClick={() => {
                                APP.model.tryCompile(() => {
                                    APP.arrangement.deleteSchrank(schrank);
                                    APP.arrangement.selectedSchrank = APP.arrangement.schraenke[0];
                                });
                            }}
                            href="#"
                        >
                            {I18N("Schrank löschen")}
                        </button>
                    </div>
                )}
            </div>
        );
    }
}
